<div class="fo-container">
  <mat-card class="fo-card" style="padding: 60px 48px;">
    <div class="fo-card-content">
      <mat-icon class="fo-icon">agriculture</mat-icon>
      <h2>Connect FieldOps Account</h2>
      <p class="fo-description">
        Connect your CNH FieldOps account to automatically sync your field operation data to Precision Gateway.
      </p>

      <button mat-raised-button color="primary" class="fo-button" (click)="connect()" [disabled]="loading">
        <mat-icon *ngIf="!loading">link</mat-icon>
        <span *ngIf="!loading">Connect to FieldOps</span>
        <span *ngIf="loading">Redirecting...</span>
      </button>

      <p class="fo-error" *ngIf="error">{{ error }}</p>
    </div>
  </mat-card>
</div>
